/**
	 * load all chapters from Custom Post-type Chapters into Navigation list
	 * waits for chapter data from loadChapterData.js
	 */
!( ( loadChapterData ) => {

	function makeChapterLink( chapterObj, index ) {
		const li = document.createElement( 'li' );
		const a = document.createElement( 'a' );
		const small = document.createElement( 'small' );


		li.classList = 'menu-item chapterItem';
		a.classList.add( 'chapterLink' );
		small.classList.add( 'nav_chapter_subtitle' );

		a.innerText = chapterObj.title.rendered;
		a.href = `/chapter/${chapterObj.slug}/`;
		a.setAttribute( 'data-chapter-index', index );
		small.innerText = chapterObj.acf.sub_title && `<${chapterObj.acf.sub_title}>`;

		li.append( a, small );

		return li;
	}

	function createChaptersNavList( chapters ) {
		const fragment = document.createDocumentFragment();
		chapters.forEach( ( item, i ) => {
			fragment.appendChild( makeChapterLink( item, i ) )
		} );
		return fragment;
	}

	function populateChaptersInNav( chapters ) {
		const target = document.querySelector( '#pulloutNav_menu .menu-item--chapters ' );
		const navItems = createChaptersNavList( chapters );

		const ul = document.createElement( 'ul' );
		ul.classList.add( 'sub-menu' );
		ul.append( navItems );
		target.append( ul );
	}

	// on load - wait for chapter data from loadChapterData.js
	loadChapterData.then( ( chapters ) => {
		populateChaptersInNav( chapters );
		// set page status
		setCurrentPageStatusInNav();

	} );
} )( loadChapterData );